import { getIn } from 'formik'
import { InputDate } from '../../InputDate'

export const InputDateForm = ({ field, form, label, ...props }) => {
  const handleChange = (e) => {
    form.setFieldValue(field.name, e)
  }

  const error = getIn(form.errors, field.name)
  const touched = getIn(form.touched, field.name)

  return (
    <InputDate
      name={field.name}
      label={label}
      isInvalid={!!error && !!touched}
      value={field.value}
      onChange={handleChange}
      {...props}
    />
  )
}
